import React from 'react';

export default React.createContext({
  open: true,
  applications: [],
  setOpen: () => {},
  setApplications: () => {},
});
